import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';

import { Router, ActivatedRoute, UrlTree } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private urlkeys = ["com_n", "com_p", "com_id", "com_em", "distrib", "contrat_id", "client_id", "type_doc", "token"];

  public logged = true;

  constructor(private fb: FormBuilder, private servicelogin: LoginService, private route: ActivatedRoute) {
  }

  ngOnInit() {

    this.route.queryParams.subscribe(data => { // get url params
      let res = true;
      console.log(data, this.urlkeys)
      for (let key of this.urlkeys) {
        if (!(key in data)) {
          res = false;
          console.log(key);
        }
      }
      if (res) {
        this.auth(data);
      }
      else {
        if (this.servicelogin.verif()) {
          this.logged = true;
        }
        else {
          this.logged = false;
        }
      }
    })


  }

  auth(data) {
    this.logged = true;
    this.servicelogin.auth(data).subscribe(data => {
      console.log(data);
      if (!data) {
        this.logged = false;
      }
    }, () => {
      this.logged = false;
    });
  }



}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/login/login.component.ts